import { IEducationalScenarioItem } from "../../educational-scenario-items";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IEducationalScenarioItemResource } from "../types/IEducationalScenarioItemResource";

export type IEducationalScenarioItemDeleteMutationParameters = {
    educationalScenarioItem: RelationalValue<IEducationalScenarioItemResource>;
};

export type IEducationalScenarioItemDeleteMutationResult = IEducationalScenarioItem;

export const educationalScenarioItemDeleteMutation: IApiMutationFunction<
    IEducationalScenarioItemDeleteMutationParameters
> = ({ educationalScenarioItem }) => {
    return {
        method: "DELETE",
        url: `/educational_scenario_items/${mapRelationalValue(educationalScenarioItem)}`,
    };
};

export const useEducationalScenarioItemDeleteMutation = createApiMutationHook<
    IEducationalScenarioItemDeleteMutationParameters,
    IEducationalScenarioItemDeleteMutationResult
>(educationalScenarioItemDeleteMutation);
